// extracted by mini-css-extract-plugin
export var indeterminate = "_6l-5";
export var md = "_6l-4";
export var semantic = "_6l-6";
export var sm = "_6l-3";
export var text = "_6l-7";
export var toggleInput = "_6l-0";
export var toggleSwitch = "_6l-1";
export var xs = "_6l-2";